import api from './api.js';
class Reports {
    constructor(){
        this.url_reports = 'Reports'
    }
    types(){
        return api.get(`${this.url_reports}/Orders/Types`);
    }
    generate(data){
    //   return `${api.base_url}/${this.url_reports}/Orders/${data.OrderId}/Types/${data.ReportTypeId}`;
    //   return `${api.base_url}/${this.url_reports}/Orders/${data.OrderId}/Types/${data.ReportTypeId}/public`;
        return api.get(`${this.url_reports}/Orders/${data.OrderId}/Types/${data.ReportTypeId}`,null,null,'blob' );
    }   
}

export default new Reports
